module.exports = __webpack_public_path__ + "img/ddd-ruler.b60692c3.png";